import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { UserChip } from "@/components/UserChip";

export function FollowListDialog({ userId, kind, onClose }) {
  const [list, setList] = useState(null);
  useEffect(() => { if (kind) { setList(null); api.get(`/users/${userId}/${kind}`).then((r) => setList(r.data)).catch(() => setList([])); } }, [userId, kind]);
  return (
    <Dialog open={!!kind} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[80vh] w-[calc(100vw-2rem)] max-w-md overflow-y-auto" data-testid="follow-list-dialog">
        <DialogHeader><DialogTitle>{kind === "followers" ? "Seguidores" : "Seguindo"}</DialogTitle></DialogHeader>
        {!list && <Loader2 className="mx-auto animate-spin text-muted-foreground" />}
        {list?.length === 0 && <p className="py-6 text-center text-sm text-muted-foreground" data-testid="follow-list-empty">{kind === "followers" ? "Ainda sem seguidores." : "Ainda não segue ninguém."}</p>}
        <div className="space-y-1" data-testid="follow-list">{list?.map((u) => <UserChip key={u.id} u={u} onClick={onClose}
          right={u.is_following ? <span className="text-[11px] font-semibold text-muted-foreground">Seguindo</span> : null} />)}</div>
      </DialogContent>
    </Dialog>
  );
}
